<script setup lang="ts">
import {ref} from "vue";
import {SocialWidgetData} from "@/SocialWidget/types/types";
import CallToAction from "@/SocialWidget/Widget/CallToAction/CallToAction.vue";
import WidgetWrap from "@/SocialWidget/Widget/WidgetWrap/WidgetWrap.vue";

const props = defineProps<{
    widgetId: string,
    endpoint: string,
}>();

const widgetData = ref<SocialWidgetData | null>(null);

const fetchData = async () => {
    const response = await fetch(`${props.endpoint}/${props.widgetId}`);
    const data = await response.json();

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    widgetData.value = data as SocialWidgetData;
}
fetchData();

</script>

<template>
    <WidgetWrap
        v-if="widgetData !== null"
        :settings="widgetData"
        :endpoint="endpoint"
        :widget-id="widgetId"/>

    <CallToAction
        v-if="widgetData?.call_to_action_settings != null"
        :settings="widgetData.call_to_action_settings"
        :endpoint="endpoint"
        :widget-id="widgetId"
        :counters="widgetData.stats_counters"/>
</template>

<style scoped>

</style>
